var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IdentityResourceFormBuilder } from '@modules/IdentityServer/services/IdentityResourceFormBuilder';
import { IdentityResourceService } from '@modules/IdentityServer/services/IdentityResourceService';
import { EditFormIdentityResourcesComponent, } from '@modules/IdentityServer/component/edit-form-identity-resources/edit-form-identity-resources.component';
import { ExcepionHandlingService } from '@core/services/ExceptionHandlingService';
var IdentityResourcesEditComponent = /** @class */ (function () {
    function IdentityResourcesEditComponent(service, formBuilder, route, router, exception) {
        this.service = service;
        this.formBuilder = formBuilder;
        this.route = route;
        this.router = router;
        this.exception = exception;
        this.loading = false;
        this.submitting = false;
        this.error = null;
    }
    Object.defineProperty(IdentityResourcesEditComponent.prototype, "clientId", {
        get: function () {
            return this.route.snapshot.params.id;
        },
        enumerable: true,
        configurable: true
    });
    IdentityResourcesEditComponent.prototype.ngOnInit = function () {
        this.loadIdentityResourceClient();
    };
    IdentityResourcesEditComponent.prototype.loadIdentityResourceClient = function () {
        return __awaiter(this, void 0, void 0, function () {
            var client, form, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.error = null;
                        this.loading = true;
                        return [4 /*yield*/, this.service.getClientInfo(parseInt(this.clientId, 10))];
                    case 1:
                        client = _a.sent();
                        form = this.formBuilder.fromModel(client);
                        this.client = client;
                        this.form = form;
                        return [3 /*break*/, 4];
                    case 2:
                        err_1 = _a.sent();
                        this.error = this.exception.errorDisplay(err_1);
                        return [3 /*break*/, 4];
                    case 3:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IdentityResourcesEditComponent.prototype.onSubmit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var client, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.formComponent.removeItem();
                        if (this.form.invalid) {
                            return [2 /*return*/];
                        }
                        client = this.formBuilder.map(this.form, this.client);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.error = null;
                        this.loading = true;
                        this.submitting = true;
                        return [4 /*yield*/, this.service.updateIdentityResourceClient(client)];
                    case 2:
                        _a.sent();
                        this.router.navigate(['identity-resources']);
                        return [3 /*break*/, 5];
                    case 3:
                        err_2 = _a.sent();
                        this.error = this.exception.errorDisplay(err_2);
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        this.submitting = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return IdentityResourcesEditComponent;
}());
export { IdentityResourcesEditComponent };
